class PostEntry
    constructor: (el) ->
        @.$el = el ? null
        @.$answerButton = @.$el.querySelector '.post-entry__answer'
        @.$bookmarkButton = @.$el.querySelector '.post-entry__bookmark'
        @.$deletePostButton = @.$el.querySelector '.post-entry__edit-menu__delete'
        @.$editPostButton = @.$el.querySelector '.post-entry__edit-menu__edit'
        @.$editMenu = @.$el.querySelector '.post-entry__edit-menu'
        @.$kebabButton = @.$el.querySelector '.post-entry__kebab'
        @.$likeButton = @.$el.querySelector '.post-entry__like'
        @.$quoteButton = @.$el.querySelector '.post-entry__quote'
        @.$reportPostButton = @.$el.querySelector '.post-entry__edit-menu__report'

        @.bookmarked = if @.$bookmarkButton then @.$bookmarkButton.classList.contains 'icon-bookmark-marked-before'
        @.liked = if @.$likeButton then @.$likeButton.classList.contains 'icon-like-marked-before' else false
        @.likes = if @.$likeButton then parseInt @.$likeButton.textContent, 10 else 0
        @.postId = @.$el.dataset?.postId ? false
        @.writeAllowed = @.$el.dataset?.wa == 'true'

        @.InitEvents()
        @.$el.classList.add 'post-entry--bound'
        return

    DispatchChangeEvent: ->
        @.$el.dispatchEvent new CustomEvent 'post-entry-change', {
            bubbles: false,
            detail: {
                bookmarked: @.bookmarked,
                liked: @.liked,
                likes: @.likes
            }
        }
        return
    
    InitEvents: ->
        self = @
        if @.$likeButton
            @.$likeButton.addEventListener 'like-button-state', (e) ->
                self.liked = e.detail.liked
                self.likes = e.detail.count
                self.DispatchChangeEvent()
                return
        if @.$bookmarkButton
            @.$bookmarkButton.addEventListener 'bookmark-button-state', (e) ->
                self.bookmarked = e.detail.active
                self.DispatchChangeEvent()
                return
        if @.$answerButton && @.writeAllowed
            @.$answerButton.addEventListener 'click', (e) ->
                window.dispatchEvent new CustomEvent 'post-entry-answer', {
                    bubbles: false,
                    detail: {
                        element: self.$el
                    }
                }
                return
        if @.$quoteButton && @.writeAllowed
            @.$quoteButton.addEventListener 'click', (e) ->
                quotedText = if self.$el.querySelector('.post-entry__text .typo3-forum__unformatted-text') then self.$el.querySelector('.post-entry__text .typo3-forum__unformatted-text').innerHTML else self.$el.querySelector('.post-entry__text').innerHTML
                window.dispatchEvent new CustomEvent 'post-entry-quote', {
                    bubbles: false,
                    detail: {
                        element: self.$el,
                        text: quotedText
                    }
                }
                return
        if @.$kebabButton && @.$editMenu
            if !@.$editPostButton && !@.$deletePostButton && !@.$reportPostButton
                @.$kebabButton.remove()
                @.$editMenu.remove()
                @.$kebabButton = null
                @.$editMenu = null
            else
                @.$kebabButton.addEventListener 'kebab-button-clicked', (e) ->
                    self.$editMenu.classList.toggle 'post-entry__edit-menu--open'
                    return
                if @.$editPostButton
                    @.$editPostButton.addEventListener 'click', (e) ->
                        self.$editMenu.classList.remove 'post-entry__edit-menu--open'
                        self.$el.dispatchEvent new CustomEvent 'post-entry-edit-click', {
                            bubbles: false,
                            detail: {
                                postId: self.$el.dataset?.postId ? false
                                textContent: self.$el.querySelector('.post-entry__text').innerHTML
                            }
                        }
                        return
                if @.$deletePostButton
                    @.$deletePostButton.addEventListener 'click', (e) ->
                        self.$editMenu.classList.remove 'post-entry__edit-menu--open'
                        self.$el.dispatchEvent new CustomEvent 'post-entry-delete-click', {
                            bubbles: false,
                            detail: {
                                postId: self.$el.dataset?.postId ? false
                            }
                        }
                        return
                if @.$reportPostButton
                    @.$reportPostButton.addEventListener 'click', (e) ->
                        self.$editMenu.classList.remove 'post-entry__edit-menu--open'
                        self.$el.dispatchEvent new CustomEvent 'post-entry-report-click', {
                            bubbles: false,
                            detail: {
                                postId: self.$el.dataset?.postId ? false
                            }
                        }
                        return
        return

BindPostEntries = ->
    document.querySelectorAll '.post-entry:not(.post-entry--bound)'
        .forEach (el) ->
            new PostEntry el
            return
    return

window.addEventListener 'bind-components', BindPostEntries

class PostEntryCreate
    constructor: (options) ->
        @.$el = null
        @.options = options ? {}

        @.CreateElement()
        if !@.options?.bindLater
            new PostEntry @.$el
        return @.$el
    
    CreateElement: ->
        @.$el = document.createElement 'div'
        @.$el.classList.add 'post-entry'
        if @.options?.color
            @.$el.classList.add 'post-entry--' + @.options.color
        if @.options?.id
            @.$el.id = @.options.id
        if @.options.attrs
            @.$el = window.appUtils.Attributes @.options.attrs, @.$el
        if @.options?.editMenu
            @.$el.appendChild new KebabButtonCreate {
                attrs: {
                    class: ['post-entry__kebab']
                }
            }
        if @.options?.ownerId
            @.$el.dataset.ownerId = @.options.ownerId
        if @.options?.postId
            @.$el.dataset.postId = @.options.postId
        @.$el.innerHTML += "
            #{ if @.options?.editMenu then "
                <nav class='post-entry__edit-menu'>
                    <ul>
                        #{ if @.options?.editMenu?.allowEdit then "
                            <button type='button' class='post-entry__edit-menu__edit'>#{ @.options?.editPostText ? 'Beitrag bearbeiten' }</button>
                        " else "" }
                        #{ if @.options?.editMenu?.allowDelete then "
                            <button type='button' class='post-entry__edit-menu__delete'>#{ @.options?.deletePostText ? 'Beitrag löschen' }</button>
                        " else "" }
                    </ul>
                </nav>
            " else "" }
            <div class='post-entry__user-info'></div>
            <div class='post-entry__content'>
                <div class='post-entry__head'><div class='kicker'>#{ @.options?.postDate?.day ? 'n/a' }</div>#{ if @.options?.postDate?.time then "<span>#{ @.options.postDate.time } #{ @.options?.postDate?.timeUnit ? 'Uhr'}</span>" else "" }</div>
                <div class='post-entry__text'></div>
                <div class='post-entry__interaction'>
                </div>
            </div>
        "
        @.$el.querySelector '.post-entry__text'
            .replaceWith window.CreateRichtext {
                attrs: {
                    class: ['post-entry__text', 'typo3-forum-text']
                }
                textContent: @.options?.text ? '<p>Text</p>'
            }
        @.$el.querySelector '.post-entry__user-info'
            .appendChild new UserInfoCreate (@.options?.userInfo ? {})
        interActionEl = @.$el.querySelector '.post-entry__interaction'
        if !@.options?.hideLikeButton
            likeButton = window.CreateLikeButton {
                count: @.options?.count ? 0
                disabled: !@.options?.loggedIn
                liked: @.options?.liked ? false
            }
            likeButton.classList.add 'post-entry__like'
            interActionEl.appendChild likeButton
        if !@.options?.hideBookmarkButton
            bookmarkButton = new BookmarkButtonCreate {
                active: @.options?.bookmarked ? false,
                text: @.options?.bookmarkText ? null,
                textActive: @.options?.bookmarkTextActive ? null
            }
            bookmarkButton.classList.add 'post-entry__bookmark'
            interActionEl.appendChild bookmarkButton
        if @.options?.loggedIn && @.options?.writeAllowed
            interActionEl.innerHTML += "
                <button type='button' class='post-entry__button post-entry__quote icon-quote-before'>#{ @.options?.answerText ? 'Antworten' }</button>
                <button type='button' class='post-entry__button post-entry__answer icon-answer-before'>#{ @.options?.quoteText ? 'Zitieren' }</button>
            "
        return

window.CreatePostEntry = (options) ->
    return new PostEntryCreate options